var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BButton',{staticClass:"play-button",attrs:{"disabled":_vm.disabled,"variant":"link"}},[_c('Icon',{staticClass:"play-icon",attrs:{"name":_vm.iconClassEnum.PLAY_BUTTON}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }